export const System = {
  appReleaseVersion: '15.1',
};
